import React from 'react';
import { millisecondToISODate } from '../../common/utils';
import { Stack } from '@mui/material';
import AccurityIcon from '../../icon/components/AccurityIcon';
import { useAccurityTimezone } from '../../timezoneProvider/AccurityTimezoneProvider';
import AccurityButton from '../../buttons/components/AccurityButton';
import AccurityIconButton from '../../buttons/components/AccurityIconButton';
function getTitleIconColor(titleIconColor) {
    return titleIconColor ? titleIconColor + ".main" : undefined;
}
var NotificationCenterCard = function (_a) {
    var title = _a.title, titleIcon = _a.titleIcon, titleIconColor = _a.titleIconColor, date = _a.date, unread = _a.unread, actionText = _a.actionText, actionClick = _a.actionClick, onDismiss = _a.onDismiss, children = _a.children;
    var timezone = useAccurityTimezone();
    var dismissButton = Boolean(onDismiss) ? (React.createElement(AccurityIconButton, { onClick: onDismiss, iconName: "mui:Close", size: "small", className: "notificationCenter__dismissButton" })) : null;
    return (React.createElement("div", { className: 'notificationCenterCard__container' },
        React.createElement("div", { className: "notificationCenterCard" + (unread ? ' notificationCenterCard--unread' : '') },
            React.createElement(Stack, { direction: "row", alignItems: "center" },
                titleIcon && (React.createElement(AccurityIcon, { iconName: titleIcon, sx: {
                        color: getTitleIconColor(titleIconColor),
                        marginRight: 1,
                    } })),
                React.createElement("span", null, title)),
            React.createElement("div", { className: 'notificationCenterCard__content' }, children),
            React.createElement("div", { className: 'notificationCenterCard__footer' },
                React.createElement("div", { className: 'notificationCenterCard__footerLeft' },
                    React.createElement("span", null, date ? millisecondToISODate(date, timezone) : '')),
                React.createElement("div", { className: 'notificationCenterCard__footerRight' }, actionText && actionClick &&
                    React.createElement(AccurityButton, { onClick: actionClick, name: "notificationAction", color: "secondary", size: "small" }, actionText)))),
        dismissButton));
};
export default NotificationCenterCard;
//# sourceMappingURL=NotificationCenterCard.js.map